import {Controller} from '@stimulus/core'
import KeenSlider from 'keen-slider'

// data-controller='keen-slider'

export default class extends Controller {
  static values = {
    imageUrls: Array
  }
 
  connect() {
    const images = this.imageUrlsValue

    new KeenSlider('#keen-slider', {
            loop: true,
            selector: ".carousel__cell",
            renderMode: "custom",
            mode: "free-snap",
            detailsChanged: rotate,
            created: rotateSlider
        }
    )

    function rotateSlider(slider) {
        const z = 600
        const deg = 360 / slider.slides.length
        slider.slides.forEach((element, idx) => {
          element.style.transform = `rotateY(${deg * idx}deg) translateZ(${z}px)`
        })
        rotate(slider)
        loadImages(slider)
    }

    function rotate(slider) {
        const z = 600
        const deg = 360 * slider.track.details.progress
        slider.container.style.transform = `translateZ(-${z}px) rotateY(${-deg}deg)`
    }

    function loadImages(slider) {
        slider.slides.forEach((element, idx) => {
          setTimeout (() => {
            element.querySelector("img").setAttribute("src", images[idx])
            element.querySelector("img").style.opacity = '1'
          }, 800
          )
        })
    }
  }
}
